import { ActionReducer, MetaReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { CHECKOUT_LOCALSTORAGE_KEY } from '../constants';
import * as fromAddresses from './addresses';
import * as fromCountries from './countries';
import * as fromOrder from './order';
import * as fromPayment from './payment';
import * as fromPaymentMethods from './payment-methods';

export const reducers = {
  addresses: fromAddresses.reducer,
  countries: fromCountries.reducer,
  order: fromOrder.reducer,
  paymentMethods: fromPaymentMethods.reducer,
  payment: fromPayment.reducer,
};

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: ['addresses'],
    rehydrate: true,
    storageKeySerializer: () => CHECKOUT_LOCALSTORAGE_KEY,
  })(reducer);
}

export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];
